define("plugin/shortcuts/input-fields",function(){"use strict";
// All html tag types that are supposed to prevent shortcuts to trigger
return["TEXTAREA","INPUT"]});